import { ReactNode } from "react";
import cn from "clsx";

// ValueBar — Zahl (rechtsbuendig, Lexend) ueber einem festen Track-Balken,
// Fuellung relativ zum Listen-Maximum. Konsumiert nur --bar-track / --bar-fill.
// Breite steuert der Aufrufer (z.B. w-28 = ~112px) via className.
export interface ValueBarProps {
  value: number;
  /** Listen-Maximum, gegen das die Fuellung skaliert. */
  max: number;
  /** Optionaler Anzeige-Override (z.B. "~101"); sonst der Zahlwert. */
  display?: ReactNode;
  /** Gedaempfte Darstellung (z.B. wenn kein Wert / "—"). */
  dim?: boolean;
  className?: string;
}

export function ValueBar({ value, max, display, dim = false, className }: ValueBarProps) {
  const pct = max > 0 && value > 0 ? Math.max(3, Math.min(100, Math.round((value / max) * 100))) : 0;
  return (
    <div className={cn("flex flex-col items-end gap-1.5", className)}>
      <span
        className={cn(
          "font-numeric text-[0.86rem] font-semibold tabular-nums leading-none",
          dim ? "text-text-3" : "text-text",
        )}
      >
        {display ?? value}
      </span>
      <div className="h-[5px] w-full rounded-full bg-bar-track overflow-hidden" aria-hidden="true">
        <div className="h-full rounded-full bg-bar-fill/55" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default ValueBar;
